"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _dist = require("package_ui_ihm/dist");
var _Table = _interopRequireDefault(require("@mui/material/Table"));
var _TableBody = _interopRequireDefault(require("@mui/material/TableBody"));
var _TableCell = _interopRequireDefault(require("@mui/material/TableCell"));
var _TableContainer = _interopRequireDefault(require("@mui/material/TableContainer"));
var _TableHead = _interopRequireDefault(require("@mui/material/TableHead"));
var _TableRow = _interopRequireDefault(require("@mui/material/TableRow"));
var _Paper = _interopRequireDefault(require("@mui/material/Paper"));
var _dompurify = _interopRequireDefault(require("dompurify"));
var _react = require("react");
var _reactRouterDom = require("react-router-dom");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; } /**
* Nom : treatmentOccurenceDetails.js
* Description : Ce fichier contient la définition de la page treatmentOccurenceDetails 
*               Cette page affiche les informations détaillées d'un traitement réalisé sur un produit client
* Date de création : 30 septembre 2025
*/ /* CSS et assets */ /* Bibliothèques et composants */ /* Hook */ /**
* TreatmentOccurenceDetails : affiche la page qui contient les informations détaillées d'un traitement réalisé sur un produit client
*                             un lien permet de revenir vers la page qui liste les traitements réalisés sur le produit client
*
* Type : page 
*
* Parametres : 
*  None
*/
function TreatmentOccurenceDetails() {
  //Define useParam
  var _useParams = (0, _reactRouterDom.useParams)(),
    equipmentId = _useParams.equipmentId,
    treatmentParamId = _useParams.treatmentParamId,
    id = _useParams.id;

  // Define useState hooks
  var _useState = (0, _react.useState)(null),
    _useState2 = _slicedToArray(_useState, 2),
    treatmentOccurence = _useState2[0],
    setTreatmentOccurence = _useState2[1];
  var _useState3 = (0, _react.useState)(null),
    _useState4 = _slicedToArray(_useState3, 2),
    statusTreatmentOccurence = _useState4[0],
    setStatusTreatmentOccurence = _useState4[1];
  var _useState5 = (0, _react.useState)([]),
    _useState6 = _slicedToArray(_useState5, 2),
    phaseLogs = _useState6[0],
    setPhaseLogs = _useState6[1];
  var _useState7 = (0, _react.useState)(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isDataLoading = _useState8[0],
    setDataLoading = _useState8[1];
  var _useState9 = (0, _react.useState)(''),
    _useState0 = _slicedToArray(_useState9, 2),
    textNotes = _useState0[0],
    setTextNotes = _useState0[1];
  var _useState1 = (0, _react.useState)(null),
    _useState10 = _slicedToArray(_useState1, 2),
    statusNotes = _useState10[0],
    setStatusNotes = _useState10[1];

  // Define useContext hooks
  var _useAuth = (0, _dist.useAuth)(),
    authStatus = _useAuth.authStatus,
    authToken = _useAuth.authToken,
    currentUser = _useAuth.currentUser;
  var _useApi = (0, _dist.useApi)(),
    path = _useApi.path,
    applicationName = _useApi.applicationName;

  // Define useScreenWidth hooks
  var screenWidth = (0, _dist.useScreenWidth)();

  // Define functions
  function retrieveData() {
    return _retrieveData.apply(this, arguments);
  }
  function _retrieveData() {
    _retrieveData = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var token, headers, _yield$Promise$all, _yield$Promise$all2, resPhaseLogs, resTreatmentOccurence, _yield$Promise$all3, _yield$Promise$all4, dataPhaseLogs, dataTreatmentOccurence;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            // Token
            token = "Bearer " + authToken; // Headers
            headers = {
              accept: 'application/json',
              Authorization: token
            }; // Requests in parallel to win time 
            _context.n = 1;
            return Promise.all([
            // PhaseLogs
            fetch(path + "/api/eq-phlo/?treatment_occurence_id=" + id, {
              method: 'GET',
              credentials: 'include',
              mode: 'cors',
              headers: headers
            }),
            // TreatmentOccurence details
            fetch(path + "/api/eq-troc/" + id + "/", {
              method: 'GET',
              credentials: 'include',
              mode: 'cors',
              headers: headers
            })]);
          case 1:
            _yield$Promise$all = _context.v;
            _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
            resPhaseLogs = _yield$Promise$all2[0];
            resTreatmentOccurence = _yield$Promise$all2[1];
            _context.n = 2;
            return Promise.all([resPhaseLogs.json(), resTreatmentOccurence.json()]);
          case 2:
            _yield$Promise$all3 = _context.v;
            _yield$Promise$all4 = _slicedToArray(_yield$Promise$all3, 2);
            dataPhaseLogs = _yield$Promise$all4[0];
            dataTreatmentOccurence = _yield$Promise$all4[1];
            // Set variables
            setPhaseLogs(dataPhaseLogs["results"]);
            setStatusTreatmentOccurence(resTreatmentOccurence["status"]);
            setTreatmentOccurence(dataTreatmentOccurence);
            setTextNotes(dataTreatmentOccurence['notes']);
            // Dataloading
            setDataLoading(false);
          case 3:
            return _context.a(2);
        }
      }, _callee);
    }));
    return _retrieveData.apply(this, arguments);
  }
  var handleSave = function handleSave(event) {
    event.preventDefault();
    var safeText = _dompurify["default"].sanitize(textNotes);
    saveNotes(safeText);
  };
  function saveNotes(_x) {
    return _saveNotes.apply(this, arguments);
  } // Define useEffect hooks
  function _saveNotes() {
    _saveNotes = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(text) {
      var token, form_data, response;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            // Token
            token = "Bearer " + authToken; // Création du Form Data
            form_data = new FormData();
            form_data.append("new_notes", text);
            // Update TreatmentOccurence
            _context2.n = 1;
            return fetch(path + "/api/eq-troc/" + id + "/save-notes/", {
              method: 'PATCH',
              credentials: 'include',
              mode: 'cors',
              headers: {
                accept: 'application/json',
                //'Content-Type': 'multipart/form-data',  cette ligne ne doit pas être utilisée avec FormData sinon erreur
                Authorization: token
              },
              body: form_data
            });
          case 1:
            response = _context2.v;
            setStatusNotes(response["status"]);
          case 2:
            return _context2.a(2);
        }
      }, _callee2);
    }));
    return _saveNotes.apply(this, arguments);
  }
  (0, _react.useEffect)(function () {
    if (authStatus === 200) {
      setDataLoading(true);
      retrieveData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Render component
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    children: [applicationName === "BOXILUMIX" ? currentUser && (currentUser["role_name"] === "AT_ADMIN" || currentUser["role_name"] === "AT_SUPPORT") ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_dist.CompanyBar, {
      name_app: "BOXILUMIX"
    }) : null : /*#__PURE__*/(0, _jsxRuntime.jsx)(_dist.CompanyBar, {
      name_app: "BOXIBRAIN"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_dist.TabC, {
      tabNumber: 1
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: screenWidth > 650 ? 'App' : 'App-ss',
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_dist.Container, {
        children: isDataLoading ? /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
          children: "Chargement des donn\xE9es"
        }) : statusTreatmentOccurence === 200 ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("h1", {
              children: ["Traitements ", treatmentOccurence["treatment_param"]["name"], " du ", treatmentOccurence["start_date"], " au ", treatmentOccurence["end_date"]]
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: "flex-row justify-start margin-left margin-bottom margin-top",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              className: "link-border",
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_dist.BackPage, {
                path: '/treatment-occurences/' + equipmentId + '/' + treatmentOccurence["treatment_param"]['id'],
                children: "Retour \xE0 la liste des traitements r\xE9alis\xE9s"
              })
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            className: screenWidth > 650 ? 'grid-1-1-1 margin-bottom' : 'margin-bottom',
            children: [applicationName === "BOXILUMIX" ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_dist.Table, {
              labels: ['Date de début', 'Date de fin'],
              datas: [treatmentOccurence["start_date"], treatmentOccurence["end_date"]]
            }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_dist.Table, {
              labels: ['Type de fin', 'Date de début', 'Date de fin'],
              datas: [treatmentOccurence["end_type"], treatmentOccurence["start_date"], treatmentOccurence["end_date"]]
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {})]
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            className: "margin-bottom margin-top",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
              className: "table-cell table-label",
              children: "Logs phases"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableContainer["default"], {
              component: _Paper["default"],
              className: "margin-bottom margin-top table-border",
              children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Table["default"], {
                sx: {
                  minWidth: 300
                },
                size: "small",
                "aria-label": "a dense table",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_TableHead["default"], {
                  children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_TableRow["default"], {
                    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
                      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
                        className: "table-label",
                        children: "Date de d\xE9but"
                      })
                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
                      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
                        className: "table-label",
                        children: "Date de fin"
                      })
                    }), applicationName === "BOXILUMIX" ? null : /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
                      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
                        className: "table-label",
                        children: "Type de fin"
                      })
                    })]
                  })
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableBody["default"], {
                  children: phaseLogs && phaseLogs.length !== 0 ? phaseLogs.map(function (phaseLog) {
                    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_TableRow["default"], {
                      sx: {
                        '&:last-child td, &:last-child th': {
                          border: 0
                        }
                      },
                      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
                        component: "th",
                        scope: "row",
                        children: phaseLog['start_date']
                      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
                        children: phaseLog['end_date']
                      }), applicationName === "BOXILUMIX" ? null : /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
                        children: phaseLog['end_type']
                      })]
                    }, phaseLog.id);
                  }) : null
                })]
              })
            })]
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
              className: screenWidth > 650 ? 'flex-row' : null,
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
                className: "table-cell table-label",
                children: "Notes"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                className: "link link-icon",
                onClick: handleSave,
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
                  src: _dist.SaveIcon,
                  alt: "save_icon",
                  className: "link-img"
                })
              })]
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_dist.Editor, {
              value: textNotes,
              setValue: setTextNotes,
              className: "margin-bottom margin-top table-border"
            })]
          })]
        }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
            children: "Aucun traitement !"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: "flex-row justify-start margin-left margin-bottom margin-top",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              className: "link-border",
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_dist.BackPage, {
                path: '/treatment-occurences/' + equipmentId + '/' + treatmentParamId,
                children: "Retour \xE0 la liste des traitements r\xE9alis\xE9s"
              })
            })
          })]
        })
      })
    })]
  });
}
var _default = exports["default"] = TreatmentOccurenceDetails;